import { IncidentState } from '../realtime/contracts';
import type { Incident, PortalCall } from '../realtime/contracts';

export function resolveIncidentForCall(
  call: PortalCall,
  incidents: readonly Incident[],
): Incident | null {
  return incidents
    .filter(
      (incident) =>
        incident.state === IncidentState.Open &&
        incident.agencyViews.some((view) =>
          view.calls.some((linkedCall) => linkedCall.id === call.id),
        ),
    )
    .reduce<Incident | null>((newest, incident) => {
      if (newest === null) {
        return incident;
      }

      return Date.parse(incident.createdTimeUtc) > Date.parse(newest.createdTimeUtc)
        ? incident
        : newest;
    }, null);
}
